
import { Row } from 'element-ui'

export default {
  extends: Row,
}
